import {useEffect, useState} from "react";
import {Routes, Route, useNavigationType, useLocation} from "react-router-dom";
import Tool from "./pages/Tool";
import Comparator from "./pages/Comparator";
import Home from "./pages/Home";
import Methodology from "./pages/Methodology";
import Team from "./pages/Team";
import News from "./pages/News";
import Research from "./pages/Research";
import ReactGA from "react-ga4";

function App(): JSX.Element {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;
  ReactGA.initialize("G-XHS7P0WM4K");

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]',
      ) as HTMLMetaElement | null;

      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);
  const [displayValue, setDisplayValue] = useState<number | null>(0);
  const [centersCheck, setCentersCheck] = useState<boolean>(true);
  const [clear, setClear] = useState<boolean>(false);
  const [clearClickable, setClearClickable] = useState<boolean>(false);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/methodology" element={<Methodology />} />
      <Route
        path="/tool"
        element={
          <Tool
            displayValue={displayValue}
            setDisplayValue={setDisplayValue}
            centersCheck={centersCheck}
            setCentersCheck={setCentersCheck}
            clear={clear}
            setClear={setClear}
            clearClickable={true}
          />
        }
      />
      <Route
        path="/comparator"
        element={
          <Comparator
            displayValue={displayValue}
            setDisplayValue={setDisplayValue}
            centersCheck={centersCheck}
            setCentersCheck={setCentersCheck}
            clear={clear}
            setClear={setClear}
            clearClickable={false}
          />
        }
      />
      <Route path="/team" element={<Team />} />
      <Route path="/news" element={<News />} />
      <Route path="/research" element={<Research />} />
    </Routes>
  );
}
export default App;
